import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=2ca920bf&scoped=true"
import script from "./reading.vue?vue&type=script&lang=js"
export * from "./reading.vue?vue&type=script&lang=js"
import style0 from "./reading.vue?vue&type=style&index=0&id=2ca920bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca920bf",
  null
  
)

export default component.exports